import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-preferred-icons',
  templateUrl: './preferred-icons.component.html',
  styleUrls: ['./preferred-icons.component.scss'],
  standalone: false
})
export class PreferredIconsComponent implements OnInit {
  @Input() tmcPreferred = false;
  @Input() tmcPreferredLogoUrl = '';
  @Input() tmcPreferredMessage = '';
  @Input() clientPreferred = false;
  @Input() companyPreferredMessage = '';
  @Input() officePreferredMessage = '';
  preferredMessage = '';
  constructor() {}

  ngOnInit() {
    this.getPreferredMessage();
  }

  getPreferredMessage(): string {
    if (this.tmcPreferredLogoUrl) {
      this.preferredMessage =
        (this.officePreferredMessage ? this.officePreferredMessage : '') +
        ' ' +
        (this.companyPreferredMessage ? this.companyPreferredMessage : '');
    } else {
      this.preferredMessage =
        (this.tmcPreferredMessage ? this.tmcPreferredMessage : '') +
        ' ' +
        (this.officePreferredMessage ? this.officePreferredMessage : '') +
        ' ' +
        (this.companyPreferredMessage ? this.companyPreferredMessage : '');
    }

    return this.preferredMessage;
  }
}
